module.exports = __webpack_public_path__ + "static/media/carl987-055.d53324fa.jpg";